export default __webpack_public_path__ + "fonts/select-up-arrow-black.svg";